import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent, ConfirmDialogModel } from '../shared/alert-dialog/alert-dialog.component';

export enum AlertType{
  alert = 'alert',
  confirm = 'confirm'

}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private dialog: MatDialog ) { }

  showAlertDialog(message, type: AlertType) {
    const dialogData = new ConfirmDialogModel('Smth Portal', message, type);
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      height: '250px',
      width: '600px',
      data: dialogData
    });
    return dialogRef;
  }
}
